/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { MenuConfigModel } from '../../../../core/models';

export const PortalMenu: MenuConfigModel[] = [
    {
        menuTitle: 'adcs',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/adc',
        id: 'adcs',
        menuItems: [
            {
                location: '/cm/adcs/overview',
                heading: 'overview',
                id: 'adc-overview',
                iconLocation: 'centralisedManagement/icons/overview',
                hidden: false
            },
            {
                location: '/cm/adcs/list',
                heading: 'list',
                id: 'adc-list',
                iconLocation: 'centralisedManagement/icons/adc',
                hidden: true
            },
            {
                location: '/cm/adcs/shuttle',
                heading: 'adc_shuttle_management',
                id: 'adc-shuttle',
                iconLocation: 'centralisedManagement/icons/shuttle',
                hidden: true
            }
        ]
    },
    {
        menuTitle: 'scheduler',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/schedule',
        id: 'scheduler',
        menuItems: [
            {
                location: '/cm/scheduler/overview',
                heading: 'overview',
                id: 'schedule-overview',
                iconLocation: 'centralisedManagement/icons/overview',
                hidden: false
            },
            {
                location: '/cm/scheduler/schedules',
                heading: 'schedules',
                id: 'schedule-list',
                iconLocation: 'centralisedManagement/icons/schedule',
                hidden: true
            },
            {
                location: '/cm/scheduler/pipelines',
                heading: 'pipelines',
                id: 'pipelines-list',
                iconLocation: 'centralisedManagement/icons/pipelines',
                comingSoon: true,
                hidden: false,
                children: []
            }
        ]
    },
    {
        menuTitle: 'storage',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/storage-white',
        id: 'storage',
        menuItems: [
            {
                location: '/cm/storage/overview',
                heading: 'overview',
                id: 'storage-overview',
                iconLocation: 'centralisedManagement/icons/overview',
                hidden: false,
                children: []
            },
            {
                location: '/cm/storage/backups',
                heading: 'backups',
                id: 'backups',
                iconLocation: 'centralisedManagement/icons/backup',
                hidden: true,
                children: []
            }
        ]
    },
    {
        menuTitle: 'security',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/security',
        id: 'security',
        menuItems: [
            {
                location: '/cm/security/overview',
                heading: 'overview',
                id: 'security-overview',
                iconLocation: 'centralisedManagement/icons/overview',
                hidden: false
            },
            {
                location: '/cm/security/dashboard',
                heading: 'security_dashboard',
                id: 'security-dashboard',
                comingSoon: true,
                iconLocation: 'centralisedManagement/icons/dashboard',
                hidden: false
            },
            {
                location: '/cm/security/insights',
                heading: 'security_insights',
                id: 'security-insights',
                iconLocation: 'centralisedManagement/icons/insight',
                subscriptionPath: 'adc_security_insights',
                hidden: true
            },
            {
                location: '/cm/security/certificates',
                heading: 'certificates',
                id: 'security-certificates',
                iconLocation: 'shared/icons/certificate',
                subscriptionPath: 'adc_certificate_insights',
                hidden: true
            }
        ]
    },
    {
        menuTitle: 'accounts',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/account-settings',
        id: 'accounts',
        menuItems: [
            {
                location: '/cm/accounts/sso',
                heading: 'accounts_single-sign-on',
                id: 'accounts-sso',
                iconLocation: 'centralisedManagement/icons/account-settings',
                subscriptionPath: 'single_sign_on',
                hidden: true
            },
            {
                location: '/cm/accounts/two-factor-auth',
                heading: 'accounts_two_factor_auth',
                id: 'accounts-2fa',
                iconLocation: 'centralisedManagement/icons/authentication',
                subscriptionPath: '2fa',
                hidden: true
            },
            {
                location: '/cm/accounts/recover-keys',
                heading: 'recovery',
                id: 'accounts-recovery',
                iconLocation: 'shared/icons/locked',
                hidden: true
            },
            {
                location: '/cm/accounts/settings',
                heading: 'settings',
                id: 'accounts-settings',
                iconLocation: 'centralisedManagement/icons/settings',
                hidden: true
            },
        ]
    },
    {
        menuTitle: 'organization_title',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/org-white',
        id: 'organisation',
        menuItems: [
            {
                location: '/cm/organisation/users/list',
                heading: 'user_management',
                id: 'org-users',
                iconLocation: 'centralisedManagement/icons/users',
                hidden: true
            },
            {
                location: '/cm/organisation/security-group',
                heading: 'security',
                id: 'org-security',
                iconLocation: 'centralisedManagement/icons/security-group',
                hidden: true,
                children: [
                    {
                        location: '/cm/organisation/security-group/auditing',
                        heading: 'auditing',
                        id: 'auditing',
                        iconLocation: 'centralisedManagement/icons/auditing',
                        subscriptionPath: 'audit_log',
                        hidden: true
                    },
                    {
                        location: '/cm/organisation/security-group/saml',
                        heading: 'saml_title',
                        id: 'saml_title',
                        iconLocation: 'centralisedManagement/icons/saml',
                        subscriptionPath: 'single_sign_on_tailored',
                        hidden: true
                    },
                ]
            },
            {
                location: '/cm/organisation/namespaces',
                heading: 'namespaces',
                id: 'org-namespaces',
                iconLocation: 'centralisedManagement/icons/globe',
                hidden: true
            },
            {
                location: '/cm/organisation/subscriptions',
                heading: 'subscriptions',
                id: 'org-subscription',
                iconLocation: 'centralisedManagement/icons/subscription',
                hidden: false
            },
            {
                location: '/cm/organisation/billing/overview',
                heading: 'billing',
                id: 'org-billing',
                iconLocation: 'centralisedManagement/icons/billing',
                hidden: false
            },
            {
                location: '/cm/organisation/licensing',
                heading: 'licensing',
                id: 'org-licensing',
                iconLocation: 'centralisedManagement/icons/key',
                comingSoon: true,
                hidden: false
            },
            {
                location: '/cm/organisation/settings',
                heading: 'settings',
                id: 'org-settings',
                iconLocation: 'centralisedManagement/icons/settings',
                hidden: true
            }
        ]
    },
    {
        menuTitle: 'resources',
        menuSubTitle: '',
        menuTitleImage: 'centralisedManagement/icons/resources',
        id: 'resources',
        menuItems: [
            {
                location: '/cm/resources/downloads',
                heading: 'downloads',
                id: 'resources-downloads',
                iconLocation: 'shared/icons/documents',
                hidden: false
            },
            {
                location: 'https://docs.loadbalancer.org/',
                heading: 'documentation',
                id: 'resources-documentation',
                iconLocation: 'shared/icons/documents',
                hidden: false,
                externalLink: true
            }
        ]
    },
    {
        menuTitle: 'support',
        menuSubTitle: '',
        menuTitleImage: 'shared/icons/user-headset',
        id: 'support',
        menuItems: [
            {
                location: '/cm/support/tickets',
                heading: 'tickets_all',
                id: 'all-tickets',
                iconLocation: 'centralisedManagement/icons/ticket',
                hidden: true,
                children: []
            },
            {
                location: 'https://status.loadbalancer.org/',
                heading: 'service_status',
                id: 'service-status',
                iconLocation: 'centralisedManagement/icons/service-status',
                hidden: false,
                externalLink: true
            },
            {
                location: './telephone-support',
                heading: 'support_telephone',
                id: 'service-status',
                iconLocation: 'centralisedManagement/icons/phone',
                hidden: false,
                comingSoon: true
            },
            {
                location: './knowledge-base',
                heading: 'knowledge_base',
                id: 'service-status',
                iconLocation: 'centralisedManagement/icons/settings',
                hidden: false,
                comingSoon: true
            }
        ]
    }
];
